import { useState } from 'react';
import type { NextPage } from 'next';
import { Box, Container, Tab, ThemeProvider, Tabs } from '@mui/material';
import PaidIcon from '@mui/icons-material/Paid';
import DescriptionIcon from '@mui/icons-material/Description';

import theme from '../styles/theme';
import SearchView from '../components/SearchView';
import ReportView from '../components/ReportView';
import CustomTabPanel from 'ui/components/tabs/custom-tab-panel';

const Home: NextPage = () => {
  const [value, setValue] = useState<'payment' | 'report'>('payment');

  const handleChange = (
    event: React.SyntheticEvent,
    newValue: 'payment' | 'report'
  ) => {
    setValue(newValue);
  };

  return (
    <ThemeProvider theme={theme}>
      <Container maxWidth="sm" sx={{ padding: 0 }}>
        <Box
          display="flex"
          justifyContent="center"
          sx={{
            marginBottom: theme.spacing(3),
          }}
        >
          <Tabs
            value={value}
            onChange={handleChange}
            aria-label="tabs"
            sx={{ width: '100%' }}
          >
            <Tab
              icon={<PaidIcon />}
              label="Pagos"
              value="payment"
              sx={{ width: '50%' }}
            />
            <Tab
              icon={<DescriptionIcon />}
              label="Informes"
              value="report"
              sx={{ width: '50%' }}
            />
          </Tabs>
        </Box>
        <CustomTabPanel selected={value} value="payment" sx={{ padding: 0 }}>
          <SearchView />
        </CustomTabPanel>
        <CustomTabPanel selected={value} value="report" sx={{ padding: 0 }}>
          <ReportView />
        </CustomTabPanel>
      </Container>
    </ThemeProvider>
  );
};

export default Home;
